export default __webpack_public_path__ + "static/media/thumb.f466d478.jpg";